<template>
  <v-app id="app">
    <v-snackbar
      v-model="snackbar.active"
      :timeout="5000"
      right
      top
      :color="snackbar.color || ''"
    >
      {{ snackbar.text }}
      <!-- <v-btn color="white" text @click="closeSnack">Fechar</v-btn> -->
    </v-snackbar>
    <v-main v-if="status === STATUS_READY">
      <v-container style="max-width: 700px">
        <v-row>
          <v-col>
            <v-card flat color="transparent">
              <v-card-text>
                <v-img
                  src="@/assets/logo.png"
                  width="150px"
                  class="mb-5"
                ></v-img>
                No seguimento da sua participação de sinistro à
                <b>{{ meta.insurer_name }}</b
                >, com referência <b>{{ meta.sinister_number }}</b
                >, e de forma a agilizar o seu processo de regularização,
                pedimos que responda ao seguinte questionário e nos remeta
                fotografias dos danos e a documentação solicitada na sua posse.
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>

        <v-row dense>
          <v-col>
            <v-alert
              type="info"
              color="primary darken-1"
              border="left"
              style="font-size: 13px"
              text
            >
              <template #prepend>
                <v-icon color="primary darken-1" class="px-2" left>
                  mdi-clock-alert-outline
                </v-icon>
              </template>
              Agradecemos o envio desta informação no prazo de máximo de 48h,
              findo o qual este link expirará. Caso pretenda um novo link,
              agradecemos que nos contacte.
            </v-alert>
          </v-col>
        </v-row>

        <v-row dense>
          <v-col>
            <v-card class="mb-5">
              <v-card-title> Sinistro </v-card-title>

              <v-card-text class="px-6 pb-10 pt-5">
                <v-row>
                  <v-col cols="12" sm="7">
                    <v-text-field
                      :value="meta.insurer_name"
                      label="Companhia"
                      hide-details="auto"
                      outlined
                      disabled
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="5">
                    <v-text-field
                      :value="meta.sinister_number"
                      label="Nº do Sinistro"
                      hide-details="auto"
                      outlined
                      disabled
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" sm="6" md="4">
                    <v-text-field
                      v-model="form.sinister_date"
                      :error-messages="errors.sinister_date"
                      @change="save()"
                      label="Data do sinistro"
                      :max="getToday()"
                      placeholder="Indique a data em que ocorreu o sinistro"
                      type="date"
                      hide-details="auto"
                      outlined
                      persistent-placeholder
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <v-textarea
                      v-model="form.sinister_description"
                      :error-messages="errors.sinister_description"
                      @change="save()"
                      label="Descrição do sinistro"
                      placeholder="Descreva o sinistro"
                      type="date"
                      hide-details="auto"
                      outlined
                      auto-grow
                      persistent-placeholder
                    ></v-textarea>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>

        <v-row dense>
          <v-col>
            <v-card class="mb-5">
              <v-card-title> Segurado </v-card-title>
              <v-card-text class="px-6 pb-10 pt-5">
                <v-row>
                  <v-col>
                    <v-text-field
                      :value="meta.insured_name"
                      label="Nome"
                      hide-details="auto"
                      outlined
                      disabled
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" sm="6">
                    <v-text-field
                      v-mask="`### ### ###`"
                      v-model="form.nif"
                      :error-messages="errors.nif"
                      :disabled="!meta.nif_editable"
                      @change="save()"
                      label="NIF"
                      placeholder="Indique o seu NIF"
                      hide-details="auto"
                      outlined
                      persistent-placeholder
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-text-field
                      @change="save()"
                      :value="meta.policy_number"
                      label="Nº da Apólice"
                      placeholder="Indique o nº da Apólice"
                      hide-details="auto"
                      outlined
                      persistent-placeholder
                      disabled
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" sm="6">
                    <v-text-field
                      v-model="form.email"
                      :error-messages="errors.email"
                      @change="save()"
                      type="email"
                      label="E-mail (opcional)"
                      placeholder="Indique o seu e-mail"
                      hide-details="auto"
                      outlined
                      persistent-placeholder
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-text-field
                      v-model="form.phone"
                      v-mask="'### ### ###'"
                      :error-messages="errors.phone"
                      @change="save()"
                      type="tel"
                      label="Contacto Telefónico"
                      placeholder="Indique o seu contacto telefónico"
                      hide-details="auto"
                      outlined
                      persistent-placeholder
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>

        <v-row dense>
          <v-col>
            <v-card class="mb-5">
              <v-card-title> Local de Risco </v-card-title>

              <v-card-text class="px-6 pb-10 pt-5">
                <v-row>
                  <v-col cols="12" sm="4">
                    <v-text-field
                      v-mask="'####-###'"
                      v-model="form.risk_location_postal_code"
                      :error-messages="errors.risk_location_postal_code"
                      @change="save()"
                      label="Código Postal"
                      placeholder="Indique o seu código postal"
                      hide-details="auto"
                      outlined
                      persistent-placeholder
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <v-text-field
                      v-model="form.risk_location_address"
                      :error-messages="errors.risk_location_address"
                      @change="save()"
                      label="Morada"
                      placeholder="Indique a sua morada"
                      hide-details="auto"
                      outlined
                      persistent-placeholder
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <v-radio-group
                      v-model="form.remains_in_residence"
                      :error-messages="errors.remains_in_residence"
                      @change="save()"
                      label="Os danos causados pelo sinistro impedem a utilização normal da sua habitação?"
                    >
                      <v-radio label="Sim" value="Y"></v-radio>
                      <v-radio label="Não" value="N"></v-radio>
                    </v-radio-group>
                  </v-col>
                </v-row>
                <v-row dense>
                  <v-col>
                    <v-radio-group
                      v-model="form.roof_damage"
                      :error-messages="errors.roof_damage"
                      @change="save()"
                      label="O telhado ou cobertura da sua habitação foi afetado pelo sinistro?"
                    >
                      <v-radio
                        label="Sim - Pontual (pequena zona localizada)"
                        value="pontual"
                      ></v-radio>
                      <v-radio
                        label="Sim - Parcial (área significativa do telhado)"
                        value="parcial"
                      ></v-radio>
                      <v-radio
                        label="Sim - Generalizada (grande parte ou totalidade do telhado)"
                        value="generalizada"
                      ></v-radio>
                      <v-radio label="Não" value="nao"></v-radio>
                      <v-radio
                        label="Não sabe / Não consegue avaliar"
                        value="nao-sabe"
                      ></v-radio>
                    </v-radio-group>
                  </v-col>
                </v-row>
                <v-row dense>
                  <v-col>
                    <v-radio-group
                      v-model="form.water_inlet"
                      :error-messages="errors.water_inlet"
                      label="Existe entrada de água no interior da sua habitação?"
                      @change="save()"
                    >
                      <v-radio label="Sim" value="Y"></v-radio>
                      <v-radio label="Não" value="N"></v-radio>
                    </v-radio-group>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>

        <v-row dense>
          <v-col>
            <v-card class="mb-5">
              <v-card-title> Danos </v-card-title>

              <v-card-text class="px-6 pb-10 pt-5">
                <v-row>
                  <v-col>
                    <v-textarea
                      v-model="form.damage_description"
                      :error-messages="errors.damage_description"
                      @change="save()"
                      label="Existem mais danos que queira reportar? (opcional)"
                      placeholder="Descreva os danos adicionais"
                      type="date"
                      hide-details="auto"
                      outlined
                      auto-grow
                      persistent-placeholder
                    ></v-textarea>
                  </v-col>
                </v-row>
                <div class="mt-10">
                  <!-- <div class="mb-3 font-weight-medium" style="font-size: 18px">
                    Fotografias
                  </div>
                  <v-row>
                    <v-col cols="6" sm="3">
                      <v-card
                        elevation="0"
                        color="#F2F7F6"
                        height="130"
                        class="d-flex justify-center align-center"
                        link
                      >
                        <v-icon large color="primary">mdi-plus</v-icon>
                      </v-card>
                    </v-col>
                  </v-row> -->
                  <FilesUploadGallery
                    @change="load()"
                    title="Fotografias"
                    file-type="image"
                    :files="files.image"
                    @uploaded="files.image.push($event)"
                    @removed="handleFileRemoved($event, 'image')"
                    outlined
                    :countLimit="15"
                    imageMode
                  ></FilesUploadGallery>
                </div>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>

        <v-row dense>
          <v-col>
            <v-card class="mb-5">
              <v-card-title> Documentação </v-card-title>

              <v-card-text class="px-6 pb-10 pt-5">
                <v-row>
                  <v-col>
                    <v-alert
                      type="info"
                      color="primary darken-2"
                      border="left"
                      style="font-size: 13px"
                      text
                    >
                      <template #prepend>
                        <v-icon color="primary darken-1" class="px-2" left>
                          mdi-file-document-plus-outline
                        </v-icon>
                      </template>
                      Caso ainda não tenha sido enviada, agradecemos que anexe a
                      documentação seguinte.
                    </v-alert>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <FilesUploadGallery
                      @change="load()"
                      title="Caderneta Predial"
                      file-type="property_tax_registration_document"
                      :files="files.property_tax_registration_document"
                      @uploaded="
                        files.property_tax_registration_document.push($event)
                      "
                      @removed="
                        handleFileRemoved(
                          $event,
                          'property_tax_registration_document'
                        )
                      "
                      outlined
                    ></FilesUploadGallery>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <FilesUploadGallery
                      title="Relatórios Técnicos"
                      :files="files.report"
                      file-type="report"
                      @uploaded="files.report.push($event)"
                      @removed="handleFileRemoved($event, 'report')"
                      outlined
                      :countLimit="5"
                    ></FilesUploadGallery>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <FilesUploadGallery
                      title="Orçamentos"
                      :files="files.budget"
                      file-type="budget"
                      @uploaded="files.budget.push($event)"
                      @removed="handleFileRemoved($event, 'budget')"
                      outlined
                      :countLimit="5"
                    ></FilesUploadGallery>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <FilesUploadGallery
                      title="Faturas"
                      :files="files.invoice"
                      file-type="invoice"
                      @uploaded="files.invoice.push($event)"
                      @removed="handleFileRemoved($event, 'invoice')"
                      outlined
                      :countLimit="5"
                    ></FilesUploadGallery>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <FilesUploadGallery
                      title="Comprovativo bancário (IBAN)"
                      :files="files.iban"
                      file-type="iban"
                      @uploaded="files.iban.push($event)"
                      @removed="handleFileRemoved($event, 'iban')"
                      outlined
                      :countLimit="1"
                    ></FilesUploadGallery>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
        <v-row dense>
          <v-col>
            <v-alert
              type="info"
              color="primary darken-1"
              border="left"
              style="font-size: 13px"
              text
            >
              <template #prepend>
                <v-icon color="primary darken-1" class="px-2" left>
                  mdi-phone
                </v-icon>
              </template>
              Para qualquer esclarecimento ou prestação de informações
              adicionais, poderá contactar o nosso Serviço de Apoio ao Cliente
              através do número
              <a href="tel:215873833" class="primary--text text--darken-3"
                >215 873 833</a
              >
              (custo de uma chamada para a rede fixa nacional), disponível nos
              dias úteis, entre as 9h00 e as 18h00.
            </v-alert>
          </v-col>
        </v-row>
        <v-row dense>
          <v-col class="text-right">
            <v-btn
              @click="finish()"
              color="primary"
              large
              class="text-capitalize"
            >
              Submeter
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-main>

    <v-main v-else-if="status === STATUS_NOT_FOUND">
      <v-container
        class="d-flex align-center justify-center"
        style="height: 100dvh"
      >
        <div style="max-width: 400px">
          <v-img
            src="@/assets/images/states/empty.svg"
            max-width="300px"
            width="80dvw"
            class="mx-auto"
            eager
          ></v-img>

          <div class="title text-center grey--text mt-10">
            Página não encontrada
          </div>

          <div class="subtitle-1 text-center mt-1 grey--text">
            O endereço pode estar incorrecto ou o link já não é válido
          </div>
        </div>
      </v-container>
    </v-main>

    <v-main v-else-if="status === STATUS_FINISHED">
      <v-container
        class="d-flex align-center justify-center"
        style="height: 100dvh"
      >
        <div style="max-width: 400px">
          <v-img
            src="@/assets/images/states/mail-sent.svg"
            max-width="200px"
            width="80dvw"
            class="mx-auto"
            eager
          ></v-img>

          <div class="title text-center grey--text mt-10">
            Informação registada!
          </div>

          <div class="subtitle-1 text-center mt-1 grey--text">
            A sua informação foi submetida com sucesso, entraremos em contacto
            caso seja necessário.
          </div>
        </div>
      </v-container>
    </v-main>

    <v-main v-else-if="status === STATUS_LOADING">
      <v-container style="max-width: 700px">
        <v-skeleton-loader type="card"></v-skeleton-loader>
        <v-skeleton-loader type="card" class="mt-10"></v-skeleton-loader>
        <v-skeleton-loader type="card" class="mt-10"></v-skeleton-loader>
        <v-skeleton-loader type="card" class="mt-10"></v-skeleton-loader>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import FilesUploadGallery from "@/components/simpleFnol/FilesUploadGallery.vue";
import { formatDateForInput } from "@/tools/date";
import ToastsMixin from "@/mixins/ToastsMixin";

import { show, save, finish } from "@/services/simple_fnol.js";

const STATUS_READY = "ready";
const STATUS_LOADING = "loading";
const STATUS_NOT_FOUND = "not_found";
const STATUS_FINISHED = "finished";

export default {
  mixins: [ToastsMixin],

  components: {
    FilesUploadGallery,
  },

  props: {},

  data() {
    return {
      form: {},
      errors: {},
      meta: {},
      files: {},
      status: STATUS_LOADING,
      STATUS_READY,
      STATUS_LOADING,
      STATUS_NOT_FOUND,
      STATUS_FINISHED,
    };
  },

  methods: {
    getToday() {
      return formatDateForInput(new Date());
    },

    async load() {
      try {
        const response = await show(this.$route.params.token);
        this.fillResponse(response);
      } catch (error) {
        if (error.response.status === 404) {
          this.status = STATUS_NOT_FOUND;
        }
      }
    },
    async save() {
      try {
        const response = await save(this.$route.params.token, this.form);

        console.log("Saved!", response.data);
        this.errors = {};
      } catch (error) {
        console.error(error);
        if (error.response.status === 422) {
          this.errors = error.response.data.errors;
        }
      }
    },

    async finish() {
      try {
        const response = await finish(this.$route.params.token, this.form);
        this.fillResponse(response);
      } catch (error) {
        console.error(error);
        if (error.response.status === 422) {
          this.errors = error.response.data.errors;
          this.toastError("Por favor, corrija o formulário antes de submeter");
        }
      }
    },

    fillResponse(response) {
      if (response.finished) {
        this.status = STATUS_FINISHED;
        return;
      }

      this.form = response.data;
      this.meta = response.meta;
      this.files = response.files;
      this.status = STATUS_READY;
    },

    handleFileRemoved(file, fileType) {
      this.files[fileType] = this.files[fileType].filter(
        (f) => f.id !== file.id
      );
    },
  },

  computed: {
    snackbar() {
      return this.$store.getters.getSnackbar;
    },
  },

  created() {
    this.load();
  },
};
</script>

<style lang="scss">
#app {
  background-color: #f4f6f6;
}
</style>
